import { Outlet } from "react-router-dom";
import Login from "@/pages/auth/login.page";
import { useAuth } from "@/features/auth/hooks/useAuth";
import Header from "@/components/Header/Header";
import VerifyAccountPage from "./pages/verify/verify.page";
import OnboardingPage from "./pages/onboarding/onboarding.page";
import { useCurrentUserProfile } from "./store/auth/userProfile.store";
import { Box, Flex } from "@radix-ui/themes";
import Loader from "./components/Loader/Loader";

export const ProtectedRoutes = () => {
  const { isLoading, profile } = useAuth();
  const user = useCurrentUserProfile((s) => s.user);

  if (isLoading) {
    return <Loader>Loading...</Loader>;
  }

  if (!!profile && profile !== null) {
    if (profile.emailVerified === false) {
      return <VerifyAccountPage />;
    }

    if (user.onboarded === false || user.onboarded === undefined) {
      return <OnboardingPage />;
    }

    return (
      <Flex direction="column" minHeight="100vh">
        <Header />
        <Box flexGrow="1">
          <Outlet />
        </Box>
        {/* <Footer /> */}
      </Flex>
    );
  }

  return <Login />;
};
